import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { isGeneratedSchemaTitleField } from './is-generated-schema-title-field.js'

export function hasGeneratedSchemaTitleField(fields: SchemaField[]): boolean {
  return flattenFields(fields).some(isGeneratedSchemaTitleField)
}
